// Module-level pub/sub so non-React code (the axios interceptors in
// api/client.js) can push a toast without needing React context — the
// ToastProvider is the only subscriber, added once at the app root.
let listeners = [];

export function subscribeToast(fn) {
  listeners.push(fn);
  return () => { listeners = listeners.filter(l => l !== fn); };
}

export function pushToast(toast) {
  listeners.forEach(fn => fn(toast));
}
